import { Layout } from 'components/layout';
import React from 'react';
import { Button } from '../primitives/button/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../dialog/dialog';

export const Builder = () => {
  return (
    <section className="font-open-sans mt-[100px] screen-700:mt-[30px]">
      <Layout.Container>
        <div className="px-[33px]">
          <h3 className="text-plt-black font-bold text-center text-[32px] uppercase screen-700:text-lg">
            О застройщике
          </h3>
          <div className="flex items-center gap-10 mt-10 screen-900:grid screen-700:gap-2">
            <img
              className="w-[326px] h-[103px] screen-900:mx-auto"
              src="/assets/images/png/ab_logo.png"
              alt="logo"
            />
            <p className="text-center text-xl leading-[120%] screen-700:hidden pt-3">
              Группа компаний «АТЛАНТ» — девелоперский холдинг, занимающийся
              реализацией проектов жилищного строительства с 2011 года. За это
              время с участием структур ГК «АТЛАНТ» реализованы проекты общей
              площадью более 700 000 м2. В стадии реализации жилые и
              коммерческие проекты площадью 270 000 м2. Земельный банк ГК
              составляет более 1 500 000 м2. Более 10 000 квартир передано
              покупателям. На сегодняшний день осуществляет свою деятельность в
              г. Москве, Московской области, в г. Санкт-Петербурге и
              Архангельской области.
            </p>
            <p className="hidden text-center text-sm leading-[120%] screen-700:inline-block">
              Группа компаний «АТЛАНТ» — девелоперский холдинг, занимающийся
              реализацией проектов жилищного строительства с 2011 года.
            </p>
            <p className="hidden text-center text-sm leading-[120%] screen-700:inline-block">
              За это время с участием структур ГК «АТЛАНТ» реализованы проекты
              общей площадью более 700 000 м2. В стадии реализации жилые и
              коммерческие проекты площадью 270 000 м2. Земельный банк ГК
              составляет более 1 500 000 м2. Более 10 000 квартир передано
              покупателям.
            </p>
            <p className="hidden text-center text-sm leading-[120%] screen-700:inline-block">
              На сегодняшний день осуществляет свою деятельность в г. Москве,
              Московской области, в г. Санкт-Петербурге и Архангельской области.
            </p>
          </div>
          <div className="mx-auto w-fit mt-[32px] screen-500:w-full">
            <Dialog>
              <DialogTrigger asChild>
                <Button className="h-[52px] font-semibold rounded-[12px] w-fit mx-auto screen-500:w-full">
                  Документы по проекту
                </Button>
              </DialogTrigger>
              <DialogContent className="border-none bg-plt-white max-w-[600px] w-full px-[50px] rounded-[20px]">
                <DialogHeader>
                  <DialogTitle className="text-center text-3xl">
                    Документы по проекту
                  </DialogTitle>
                </DialogHeader>
                <div className="grid gap-3">
                  <a href="/docs/pd_corp_1_2.pdf?3" target='_blank'
                    className="underline text-plt-secondary text-2xl">
                    Проектная декларация. 1, 2 корпус
                  </a>
                  <a href="/docs/rns_corp_1_2.pdf" target="_blank" className="underline text-plt-secondary text-2xl">
                    Разрешение на строительство. 1, 2 корпус
                  </a>
                  <a href="/docs/pd_corp_3.pdf?3" target='_blank'
                    className="underline text-plt-secondary text-2xl">
                    Проектная декларация. 3 корпус
                  </a>
                  <a href="/docs/rns_corp_3.pdf" target="_blank" className="underline text-plt-secondary text-2xl">
                    Разрешение на строительство. 3 корпус
                  </a>
                </div>
              </DialogContent>
            </Dialog>
            <a href=" https://atlantdevelopment.ru/" target='_blank'
              className="underline text-plt-secondary text-2xl ms-4 screen-500:ms-0">
              <Button className="h-[52px] font-semibold rounded-[12px] w-fit mx-auto screen-500:w-full screen-500:mt-4">
                Ознакомиться с другими проектами
              </Button>
            </a>
          </div>
        </div>
      </Layout.Container>
    </section>
  );
};
